import { Component } from '@angular/core';
import {AnonymousConsentManagementBannerComponent} from "@spartacus/storefront";
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-anonymous-consent-management-banner',
    templateUrl: './efa-anonymous-consent-management-banner.component.html',
    imports: [NgClass, AsyncPipe, TranslatePipe]
})
export class EfaAnonymousConsentManagementBannerComponent extends AnonymousConsentManagementBannerComponent{

}
